import {createModel} from "@@/package/utils/ModelUtil";
import Model from "@@/package/mapper/Model";
import {CourseStatusType} from "~~/package/mapper/course/model/CourseStatusType";
import {CourseSkillModel} from "~~/package/mapper/course/model/CourseSkillModel";
import {CourseLearningPositionModel} from "~~/package/mapper/course/model/CourseLearningPositionModel";

export class CourseDetailModel extends Model {
  constructor(
    public id: number = 0,
    public title: string = "",
    public description: string = "",
    public skillCount: number = 0,
    public totalLearningTime: number = 0,
    public totalPoint: number = 0,
    public progress: number = 0,
    public status: CourseStatusType = CourseStatusType.NOT_STARTED,
    public skills: CourseSkillModel[] = [] as CourseSkillModel[],
    public relatedTrackInfos: CourseRelatedTrackInfoModel[] = [] as CourseRelatedTrackInfoModel[],
    public learningPosition: CourseLearningPositionModel = new CourseLearningPositionModel()
  ) {
    super();
  }

  public static create(model: Partial<CourseDetailModel>): CourseDetailModel {
    return createModel<CourseDetailModel>(CourseDetailModel, {
      ...model
    });
  }

  public get isNotStarted(): boolean {
    return [CourseStatusType.NOT_STARTED].includes(this.status)
  }
}

class CourseRelatedTrackInfoModel extends Model {
  constructor(
    public id: number = 0,
    public title: string = ""
  ) {
    super();
  }
}
